import React from 'react';
import { humanReadableFrequency } from './verificationDateHelpers';
import VerifiedIcon from './VerifiedIcon';
import Toast from '../components/Toast';
import type { VerificationUnit } from '../graphql/generated/graphql';

interface VerifiedToastProps {
  onDismiss: () => void;
  quantity: number;
  unit: VerificationUnit;
}

const VerifiedToast = ({ onDismiss, quantity, unit }: VerifiedToastProps) => (
  <Toast
    icon={<VerifiedIcon />}
    onDismiss={onDismiss}
    title="This post is verified"
    message={`You'll be asked to verify again in ${humanReadableFrequency({
      unit,
      quantity,
    })}.`}
  />
);

export default VerifiedToast;
